import { GlobalResponseObject } from '../../../common';
import { WhatsappLogDto } from './whatsapp-log.dto';

export class WhatsappLogResponseModel extends GlobalResponseObject {
    data?: WhatsappLogDto[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: WhatsappLogDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}